import { render, staticRenderFns } from "./AuthNavbar.vue?vue&type=template&id=4231fbe4&"
import script from "./AuthNavbar.vue?vue&type=script&lang=js&"
export * from "./AuthNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports